import N from "./extends3.mjs";
import * as Q from "react";
import { useUtils as L } from "./useUtils.mjs";
import { doesSectionFormatHaveLeadingZeros as C, changeSectionValueFormat as V, getDaysInWeekStr as k, getDateSectionConfigFromFormatToken as D, cleanDigitSectionValue as O, getLetterEditingOptions as S } from "./useField.utils.mjs";
import w from "./useEventCallback.mjs";
const I = 5e3, y = (m) => m.saveQuery != null, G = ({
  sections: m,
  updateSectionValue: E,
  sectionsValueBoundaries: x,
  setTempAndroidValueStr: F,
  timezone: p
}) => {
  const i = L(), [a, d] = Q.useState(null), f = w(() => d(null));
  Q.useEffect(() => {
    var s;
    a != null && ((s = m[a.sectionIndex]) == null ? void 0 : s.type) !== a.sectionType && f();
  }, [m, a, f]), Q.useEffect(() => {
    if (a != null) {
      const s = setTimeout(() => f(), I);
      return () => {
        window.clearTimeout(s);
      };
    }
    return () => {
    };
  }, [a, f]);
  const T = ({
    keyPressed: s,
    sectionIndex: u
  }, c, r) => {
    const n = s.toLowerCase(), e = m[u];
    if (a != null && (!r || r(a.value)) && a.sectionIndex === u) {
      const o = `${a.value}${n}`, l = c(o, e);
      if (!y(l))
        return d({
          sectionIndex: u,
          value: o,
          sectionType: e.type
        }), l;
    }
    const t = c(n, e);
    return y(t) && !t.saveQuery ? (f(), null) : (d({
      sectionIndex: u,
      value: n,
      sectionType: e.type
    }), y(t) ? null : t);
  }, M = (s) => {
    const u = (n, e, t) => {
      const o = e.filter((l) => l.toLowerCase().startsWith(t));
      return o.length === 0 ? {
        saveQuery: !1
      } : {
        sectionValue: o[0],
        shouldGoToNextSection: o.length === 1
      };
    }, c = (n, e, t, o) => {
      const l = (g) => S(i, p, e.type, g);
      if (e.contentType === "letter")
        return u(e.format, l(e.format), n);
      if (t && o != null && D(i, t).contentType === "letter") {
        const g = l(t), h = u(t, g, n);
        return y(h) ? {
          saveQuery: !1
        } : N({}, h, {
          sectionValue: o(h.sectionValue, g)
        });
      }
      return {
        saveQuery: !1
      };
    };
    return T(s, (n, e) => {
      switch (e.type) {
        case "month": {
          const t = (o) => V(i, o, i.formats.month, e.format);
          return c(n, e, i.formats.month, t);
        }
        case "weekDay": {
          const t = (o, l) => l.indexOf(o).toString();
          return c(n, e, i.formats.weekday, t);
        }
        case "meridiem":
          return c(n, e);
        default:
          return {
            saveQuery: !1
          };
      }
    });
  }, b = (s) => {
    const u = (r, n) => {
      const e = +`${r}`, t = x[n.type]({
        currentDate: null,
        format: n.format,
        contentType: n.contentType
      });
      if (e > t.maximum)
        return {
          saveQuery: !1
        };
      if (e < t.minimum)
        return {
          saveQuery: !0
        };
      const o = +`${r}0` > t.maximum || r.length === t.maximum.toString().length;
      return {
        sectionValue: O(i, p, e, t, n),
        shouldGoToNextSection: o
      };
    };
    return T(s, (r, n) => {
      if (n.contentType === "digit" || n.contentType === "digit-with-letter")
        return u(r, n);
      if (n.type === "month") {
        const e = C(i, p, "digit", "month", "MM"), t = u(r, {
          type: n.type,
          format: "MM",
          hasLeadingZerosInFormat: e,
          hasLeadingZerosInInput: !0,
          contentType: "digit",
          maxLength: 2
        });
        if (y(t))
          return t;
        const o = V(i, t.sectionValue, "MM", n.format);
        return N({}, t, {
          sectionValue: o
        });
      }
      if (n.type === "weekDay") {
        const e = u(r, n);
        if (y(e))
          return e;
        const t = k(i, p, n.format)[Number(e.sectionValue) - 1];
        return N({}, e, {
          sectionValue: t
        });
      }
      return {
        saveQuery: !1
      };
    }, (r) => !Number.isNaN(Number(r)));
  };
  return {
    applyCharacterEditing: w((s) => {
      const u = m[s.sectionIndex], r = !Number.isNaN(Number(s.keyPressed)) ? b(s) : M(s);
      r == null ? F(null) : E({
        activeSection: u,
        newSectionValue: r.sectionValue,
        shouldGoToNextSection: r.shouldGoToNextSection
      });
    }),
    resetCharacterQuery: f
  };
};
export {
  G as useFieldCharacterEditing
};
//# sourceMappingURL=useFieldCharacterEditing.mjs.map
